import React from 'react';
import { motion } from 'framer-motion';
import { StarIcon, QuoteIcon } from 'lucide-react';
import { testimonials } from '../data/wf';
import { CtaButton } from './CtaButton';
type StarsProps = {
  size?: string;
};
export function Testimonials() {
  if (testimonials.length === 0) return null;
  const [featured, ...rest] = testimonials;
  return <section id="opinie" aria-labelledby="testimonials-heading" className="w-full border-t border-slate-900/10 bg-white px-6 py-24 sm:px-14 sm:py-32" data-id="element-278" data-mp="3b0azifiqb1or">
      <div className="mx-auto max-w-6xl" data-id="element-279" data-mp="31zmto83ho7my">
        <div className="flex flex-col items-start gap-6 sm:flex-row sm:items-end sm:justify-between" data-id="element-280" data-mp="31yl6x6d41wpe">
          <div data-id="element-281" data-mp="2x11pxyp135tr">
            <Stars size="h-7 w-7" data-id="element-282" data-mp="2x2mlnrn2wut7" />
            <h2 id="testimonials-heading" className="mt-5 font-serif text-[2.6rem] leading-[1.02] tracking-tight text-slate-900 sm:text-6xl" data-id="element-283" data-mp="2s2i6q61tk853">
              Co mówią <em className="text-red-700" data-id="element-284" data-mp="v7c7d8oc59qg">nauczyciele</em> WF
            </h2>
          </div>
          <p className="max-w-sm text-lg leading-relaxed text-slate-900/70" data-id="element-285" data-mp="q893vso07bkl">
            Nauczyciele z całej Polski, którzy planują lekcje szybciej i z mniejszym stresem.
          </p>
        </div>

        <div className="mt-14 grid gap-5 lg:grid-cols-12" data-id="element-286" data-mp="m2yd6l5wm7sm">
          <motion.figure initial={{
          opacity: 0,
          y: 12
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-80px'
        }} transition={{
          duration: 0.3,
          ease: [0.23, 1, 0.32, 1]
        }} className="relative flex flex-col overflow-hidden rounded-3xl bg-slate-900 p-8 text-white sm:p-10 lg:col-span-5 lg:row-span-2" data-id="element-287" data-mp="78tvh4cu4ryy">
            <QuoteIcon className="h-12 w-12 text-red-500" aria-hidden="true" data-id="element-288" data-mp="q6cwplt1x6at" />
            <div className="mt-6" data-id="element-289" data-mp="v4emsqowa5vs">
              <Stars size="h-6 w-6" data-id="element-290" data-mp="v3d0fq2fhwyr" />
            </div>
            <blockquote className="mt-6 flex-1 font-serif text-2xl leading-snug sm:text-[1.9rem]" data-id="element-291" data-mp="1iu8y33tkfmdx">
              „{featured.quote}”
            </blockquote>
            <figcaption className="mt-10 flex items-center gap-4 border-t border-white/15 pt-6" data-id="element-292" data-mp="1xi0ld4puflw0">
              <Avatar name={featured.name} featured data-id="element-293" data-mp="1siwdqiikhw7s" />
              <div data-id="element-294" data-mp="1sjfn3au5jca7">
                <div className="font-semibold" data-id="element-295" data-mp="1sgtfjb79gwrz">{featured.name}</div>
                <div className="text-sm text-white/65" data-id="element-296" data-mp="1ofzr8gpwpfyk">
                  Nauczyciel(ka) WF · {featured.location}
                </div>
              </div>
            </figcaption>
          </motion.figure>

          <div className="grid gap-5 sm:grid-cols-2 lg:col-span-7" data-id="element-297" data-mp="1ejwob8n8ddak">
            {rest.map((item, i) => <motion.figure key={item.name} initial={{
            opacity: 0,
            y: 12
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            margin: '-80px'
          }} transition={{
            duration: 0.3,
            delay: 0.05 * (i + 1),
            ease: [0.23, 1, 0.32, 1]
          }} className="flex h-full flex-col rounded-3xl border border-slate-900/10 bg-stone-50 p-7" data-id="element-298" data-mp="19rmsxd3cjl0w" data-mpi={i}>
                <div className="flex items-center justify-between gap-3" data-id="element-299" data-mp="32hfffd5h42hh">
                  <Stars size="h-5 w-5" data-id="element-300" data-mp="37g0eh98zog4c" />
                  <span className="whitespace-nowrap rounded-full bg-red-700/10 px-3 py-1 text-xs font-semibold text-red-800" data-id="element-301" data-mp="37exqpa6yqtsn">
                    {item.topic}
                  </span>
                </div>
                <blockquote className="mt-5 flex-1 text-[1.05rem] leading-relaxed text-slate-900" data-id="element-302" data-mp="3gfdqo9ohzisr">
                  „{item.quote}”
                </blockquote>
                <figcaption className="mt-6 flex items-center gap-3" data-id="element-303" data-mp="2op99ejw1bbvr">
                  <Avatar name={item.name} data-id="element-304" data-mp="2oneoh5krjjro" />
                  <div className="text-sm" data-id="element-305" data-mp="2squhlrxmj1zm">
                    <div className="font-semibold text-slate-900" data-id="element-306" data-mp="2spt6jnglyfhw">{item.name}</div>
                    <div className="text-slate-900/60" data-id="element-307" data-mp="2xjdusnsefv3w">{item.location}</div>
                  </div>
                </figcaption>
              </motion.figure>)}
          </div>
        </div>

        <div className="mt-16 flex flex-col items-center gap-4 text-center" data-id="element-308" data-mp="250gp60b4n14i">
          <CtaButton label="Dołącz do zadowolonych nauczycieli" data-id="element-309" data-mp="1lwditg6ghymf" />
          <p className="text-sm text-slate-900/60" data-id="element-310" data-mp="1luk91s0jqya7">
            Natychmiastowy dostęp · 7 dni gwarancji satysfakcji
          </p>
        </div>
      </div>
    </section>;
}
function Stars({
  size = 'h-5 w-5'
}: StarsProps) {
  return <div className="flex items-center gap-1" role="img" aria-label="5 na 5 gwiazdek" data-id="element-311" data-mp="1qvgdc6ot8mg5">
      {Array.from({
      length: 5
    }).map((_, i) => <StarIcon key={i} className={`${size} fill-amber-400 text-amber-400`} aria-hidden="true" data-id="element-312" data-mp="24ltiy2e8bp2b" data-mpi={i} />)}
    </div>;
}
function Avatar({
  name,
  featured = false
}: {
  name: string;
  featured?: boolean;
}) {
  const initials = name.split(' ').map(part => part[0]).join('').slice(0, 2);
  return <div aria-hidden="true" className={`flex h-11 w-11 shrink-0 items-center justify-center rounded-full text-sm font-semibold ${featured ? 'bg-red-700 text-white' : 'bg-slate-900 text-white'}`} data-id="element-313" data-mp="29nso9htj4w1w">
      {initials}
    </div>;
}